var map = {
	"./": "5s55",
	"./404": "1Uj6",
	"./404.js": "1Uj6",
	"./about": "puyG",
	"./about.js": "puyG",
	"./index": "5s55",
	"./index.js": "5s55",
	"./writing": "YE21",
	"./writing/": "YE21",
	"./writing/demo": "BdWf",
	"./writing/demo/": "BdWf",
	"./writing/demo/index": "BdWf",
	"./writing/demo/index.js": "BdWf",
	"./writing/demo/jsCodeExample.txt": "WizQ",
	"./writing/demo/listItem.txt": "tvoG",
	"./writing/demo/pic.png": "qAGQ",
	"./writing/how-this-site-was-made": "NSeT",
	"./writing/how-this-site-was-made/": "NSeT",
	"./writing/how-this-site-was-made/index": "NSeT",
	"./writing/how-this-site-was-made/index.js": "NSeT",
	"./writing/index": "YE21",
	"./writing/index.js": "YE21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "4G+L";
module.exports = webpackContext;